import { sectionStyles, hexToRgba, resolveLinkProps, isColorDark } from '../utils';
import { getButtonIcon, resolveIconKey } from '../buttonIcons';

export default function SocialProofSection({ block = {}, primaryColor, secondaryColor, mediaFolders = {} }) {
    const { config = {}, content = {} } = block;
    const s = sectionStyles(config, primaryColor, secondaryColor);

    const text = content.text || '500+ estudiantes matriculados este mes';
    const count = content.count || '';
    const avatars = content.avatars || ['👩', '👨', '👩‍🦱', '👨‍🦰', '👩‍🦳'];

    const sectionButtons = content.buttons && content.buttons.length > 0
        ? content.buttons
        : content.cta_text ? [{ text: content.cta_text, link: content.cta_link || '#', style: 'solid', icon: '', bg_color: '', text_color: '' }] : [];

    const avatarImages = content.avatar_folder_id && mediaFolders[content.avatar_folder_id]
        ? mediaFolders[content.avatar_folder_id].slice(0, 5)
        : [];

    return (
        <section className={`py-8 md:py-10 relative ${s.radiusClass} ${s.shadowClass}`} style={s.bgStyle}>
            <div className={`${s.maxWidth} mx-auto px-4 sm:px-6 lg:px-8`}>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6">
                    {/* Avatar stack */}
                    {avatarImages.length > 0 ? (
                        <div className="flex items-center -space-x-3">
                            {avatarImages.slice(0, 5).map((img, i) => (
                                <img key={i} src={img.image_url} alt=""
                                    className="w-10 h-10 rounded-full border-2 border-white object-cover shadow-sm"
                                    style={{zIndex: 5 - i}}/>
                            ))}
                            {count && (
                                <div className="w-10 h-10 rounded-full border-2 border-white flex items-center justify-center text-xs font-bold shadow-sm"
                                    style={{backgroundColor: s.accent, color: '#fff', zIndex: 0}}>
                                    {count}
                                </div>
                            )}
                        </div>
                    ) : (
                    <div className="flex items-center -space-x-3">
                        {avatars.slice(0, 5).map((avatar, i) => (
                            <div key={i}
                                className="w-10 h-10 rounded-full flex items-center justify-center text-lg border-2 shadow-sm"
                                style={{
                                    backgroundColor: s.dark ? 'rgba(255,255,255,0.15)' : hexToRgba(s.accent, 0.08),
                                    borderColor: s.dark ? 'rgba(0,0,0,0.3)' : '#ffffff',
                                    zIndex: avatars.length - i,
                                }}>
                                {avatar}
                            </div>
                        ))}
                        {count && (
                            <div className="w-10 h-10 rounded-full flex items-center justify-center text-xs font-bold border-2 shadow-sm"
                                style={{
                                    backgroundColor: s.accent,
                                    borderColor: s.dark ? 'rgba(0,0,0,0.3)' : '#ffffff',
                                    color: '#ffffff',
                                }}>
                                {count}
                            </div>
                        )}
                    </div>
                    )}

                    {/* Text */}
                    <p className="text-sm md:text-base font-medium text-center sm:text-left" style={{ color: s.text }}>
                        {text}
                    </p>

                    {/* Optional CTA */}
                    {sectionButtons.map((btn, i) => {
                        const btnStyle = btn.style || 'solid';
                        const icon = btn.icon && getButtonIcon(resolveIconKey(btn.icon));
                        const lp = resolveLinkProps(btn.link || '#');
                        const customBg = btn.bg_color;
                        const customText = btn.text_color;
                        let cls = 'text-sm font-semibold px-5 py-2.5 rounded-full transition-all hover:scale-105 whitespace-nowrap inline-flex items-center gap-2 ';
                        let style = {};
                        if (btnStyle === 'solid' || btnStyle === 'pill') {
                            if (customBg) { style.backgroundColor = customBg; style.color = customText || (isColorDark(customBg) ? '#ffffff' : '#111827'); cls += 'hover:opacity-90'; }
                            else { style.backgroundColor = s.accent; style.color = '#ffffff'; cls += 'hover:opacity-90'; }
                        } else if (btnStyle === 'outline') {
                            if (customBg) { style.color = customBg; style.borderColor = customBg; cls += 'border-2 hover:opacity-80'; }
                            else { style.color = s.accent; style.borderColor = s.accent; cls += 'border-2 hover:opacity-80'; }
                        } else { style.color = customText || s.text; cls += 'hover:opacity-80'; }
                        if (customText && (btnStyle === 'solid' || btnStyle === 'pill')) style.color = customText;
                        return <a key={i} {...lp} className={cls} style={style}>{icon}{btn.text}</a>;
                    })}
                </div>
            </div>
        </section>
    );
}
